import React from 'react';
import { createRoot } from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import client from './ApolloClient';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {/* The outer one catches what the router-aware boundary cannot: a
        failure in the providers or the router itself, which would otherwise
        still be a blank page. It offers a reload rather than navigation,
        because at that point there may be no router to navigate with. */}
    <ErrorBoundary>
      <ApolloProvider client={client}>
        <App />
      </ApolloProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
